import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { IMachineDetailsBlockData } from './IMachineDetailsBlockData';

export const DynamicMachineDetailsBlock = dynamic<
    BlockProps<IMachineDetailsBlockData>
>(() => import('./MachineDetailsBlock').then(md => md.MachineDetailsBlock));
